import React from "react";
import { Grid } from "Components/Base/Layout/Grid";
import { Typography } from "Components/Base/DataDisplay/Typography";
import useMobileViewportCheck from "../../../Portal/web/Content/js/lib/effects/useMobileViewportCheck";
import { STYLE_DESKTOP_LIST_ITEM, STYLE_MOBILE_LIST_ITEM } from "./style";
import "./style.css";

/**
 * A list item component for displaying learning activities
 * @param {string} props.id - Unique identifier for the activity
 * @param {string} props.title - The title of the activity
 * @param {string} props.type - The type of activity
 * @param {React.ReactNode} props.chips - Chip components to display
 * @param {React.ReactNode} props.content - The main content of the activity
 * @param {React.ReactNode} props.actions - Action components to display
 * @param {boolean} [props.displayImage=false] - Whether to display the image component
 * @param {React.ReactNode} [props.imageComponent] - Image component to display
 * @returns {React.ReactElement} The learning activity list item component
 */
const LearningActivityListItem = (props) => {
  const mobileViewport = useMobileViewportCheck(
    window.matchMedia("(max-width: 900px)"),
  );

  return mobileViewport ? (
    <LearningActivityMobileListItem {...props} />
  ) : (
    <LearningActivityDesktopListItem {...props} />
  );
};

const LearningActivityDesktopListItem = ({
  title,
  type,
  chips,
  content,
  actions,
  displayImage = false,
  imageComponent,
}) => {
  return (
    <Grid
      container
      alignItems="flex-start"
      className="learning-courselist-item"
      sx={STYLE_DESKTOP_LIST_ITEM}
    >
      {displayImage && (
        <Grid item xs={"auto"} className="learning-courselist-item-image">
          {imageComponent}
        </Grid>
      )}
      <Grid
        container
        item
        xs={"auto"}
        direction="column"
        className="learning-courselist-info"
        sx={{ minWidth: "0" }}
      >
        <Grid item>
          <Typography
            variant="h3"
            title={title}
            className={"elipssis"}
            sx={{ maxWidth: "100%" }}
          >
            {title}
          </Typography>
        </Grid>
        <Grid item>{content}</Grid>
      </Grid>
      {chips ? (
        <Grid
          container
          item
          xs={"auto"}
          direction="column"
          sx={{ alignItems: "end" }}
        >
          <Grid item className="learning-courselist-item-tags">
            {chips}
          </Grid>
        </Grid>
      ) : null}
      <Grid
        item
        container
        className="learning-courselist-actions"
        sx={{ justifyContent: "flex-end", display: "flex", width: "100%" }}
      >
        {actions}
      </Grid>
    </Grid>
  );
};

const LearningActivityMobileListItem = ({
  title,
  type,
  chips,
  content,
  actions,
  displayImage = false,
  imageComponent,
}) => {
  return (
    <Grid
      item
      container
      direction="column"
      className="learning-courselist-item-mobile"
      sx={STYLE_MOBILE_LIST_ITEM}
    >
      <Grid
        item
        sx="auto"
        container
        justifyContent="space-between"
        float="right"
      >
        {displayImage && (
          <Grid item className="learning-courselist-item-image">
            {imageComponent}
          </Grid>
        )}
        <Grid item direction="column" className="learning-courselist-item-tags">
          {chips}
        </Grid>
      </Grid>

      <Grid item>
        <Typography
          variant="h3"
          title={title}
          className={"elipssis"}
          sx={{ maxWidth: "85vw" }}
        >
          {title}
        </Typography>
      </Grid>

      <Grid item>{content}</Grid>

      <Grid xs="auto" item container justifyContent="flex-end">
        {actions}
      </Grid>
    </Grid>
  );
};

export default LearningActivityListItem;

